/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgInheritanceSquareArrow = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M2 2h20v14h-2V4H4v16h8v2H2z" />
        <path d="M17.293 22.707 13.586 19l3.707-3.707 1.414 1.414L17.414 18H22v2h-4.586l1.293 1.293zM6 6h12v7.65l-.707-.903L12.04 18H6z" />
      </g>
    </g>
  </Icon>
);
export { SvgInheritanceSquareArrow as InheritanceSquareArrow };
